import api from "./apiClient";
import { qboxApi } from "./apiClient";
import reportPrompts from "@/config/report_prompts";

// 🔹 Загрузить базы данных
export const loadDatabases = async () => {
  try {
    const { data } = await api.get("/api/qb/databases");
    return data || [];
  } catch (error) {
    console.error("Failed to load databases:", error);
    return [];
  }
};

// 🔹 Получить файлы базы
export const getDatabaseFiles = async (databaseId) => {
  try {
    const { data } = await api.get(`/api/qb/databases/${databaseId}/files`);
    return data || [];
  } catch (error) {
    console.error("Failed to load database files:", error);
    return [];
  }
};

// 🔹 Обновить файлы в базе
export const updateDatabaseFiles = async (
  databaseId,
  includedFiles = [],
  deleteFiles = [],
  includedIndividualFiles = []
) => {
  try {
    const { data } = await api.put(`/api/qb/databases/${databaseId}/edit`, {
      included_files: includedFiles,
      excluded_files: deleteFiles,
      included_individual_files: includedIndividualFiles,
    });
    return data || null;
  } catch (error) {
    console.error("Failed to update database files:", error);
    return null;
  }
};

// 🔹 Обновить название базы
export const updateDatabaseName = async (databaseId, updatedName) => {
  try {
    const { data } = await api.put(`/api/qb/databases/${databaseId}/name`, {
      name: updatedName,
    });
    return data || null;
  } catch (error) {
    console.error("Failed to update database name:", error);
    return null;
  }
};

// 🔹 Загрузить базу данных (async)
export const uploadDatabase = async (formData) => {
  try {
    const { data } = await api.post(`/api/qb/upload_database_async`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data || "Database upload failed";
  } catch (error) {
    console.error("Database upload failed:", error);
    throw error;
  }
};

// 🔹 Удалить базу данных
export const deleteDatabase = async (databaseId) => {
  try {
    const { data } = await api.delete(`/api/qb/databases/${databaseId}`);
    return data || "Database deletion failed";
  } catch (error) {
    console.error("Database deletion failed:", error);
    throw error;
  }
};

// 🔹 Загрузить файл
export const uploadFile = async (formData) => {
  try {
    const { data } = await api.post(`/api/qb/upload_file`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data || "File upload failed";
  } catch (error) {
    console.error("File upload failed:", error);
    throw error;
  }
};

// 🔹 Удалить файл
export const deleteFile = async (fileId) => {
  try {
    const { data } = await api.delete(`/api/qb/files/${fileId}`);
    return data || "File deletion failed";
  } catch (error) {
    console.error("File deletion failed:", error);
    throw error;
  }
};

// 🔹 Загрузить агентов
export const loadAgents = async () => {
  try {
    const { data } = await api.get(`/api/qb/agents`);
    const reportAgent = {
      id: "report_agent",
      name: "Report Agent",
      description: "Report Agent",
    };
    const ocrAgent = {
      id: "ocr_agent",
      name: "Files Agent",
      description: "Files Agent",
    };
    return [reportAgent, ocrAgent, ...data] || [];
  } catch (error) {
    console.error("Failed to load agents:", error);
    return [];
  }
};

// 🔹 Отправить сообщение в чат
export const sendChatMessage = async (
  message,
  chatId,
  useDatabase,
  useAgent,
  messagesHistory,
  systemPrompt
) => {
  try {
    const { data } = await api.post(`/api/qb/chat`, {
      message,
      chat_id: chatId,
      use_database: useDatabase,
      use_agent: useAgent,
      messages_history: messagesHistory,
      system_prompt: systemPrompt,
    });
    return data || "Chat request failed";
  } catch (error) {
    console.error("Chat request failed:", error);
    throw error;
  }
};

export const getAudioStt = async (formData) => {
  try {
    const { data } = await qboxApi.post(`/ais/api/stt`, formData);
    return data || "getAudioStt request failed";
  } catch (error) {
    console.error("getAudioStt request failed:", error);
    throw error;
  }
};

export const reportApi = {
  shareReport: async (reportId, type = "organization", userIds = []) => {
    const body = {
      share_type: type, // or "specific_users" or "no_one"
    };

    if (type === "specific_users") {
      body.users = userIds;
    }

    try {
      const response = await api.post(`/tta/report/${reportId}/share`, body);
      return response.data;
    } catch (error) {
      console.error("Report share failed:", error);
      throw error;
    }
  },
  getShareInfo: async (reportId) => {
    try {
      const response = await api.get(`/tta/report/${reportId}/share`);
      return response.data;
    } catch (error) {
      console.error("Report share info failed:", error);
      throw error;
    }
  },
};

export const generateReport = async (
  prompts,
  agentId = "report_agent",
  title = "Генерация отчета ..."
) => {
  try {
    const { data } = await api.post(`/tta/report/generate_report`, {
      title: title,
      description: "",
      prompt:
        agentId === "report_agent"
          ? [...reportPrompts, ...prompts]
          : [...prompts],
      agent: agentId, // report_agent, ocr_agent
    });

    return await getReport(data.report_id);
  } catch (error) {
    console.error("Ошибка при анализе с помощью AI:", error);
    throw error;
  }
};

export const getReport = async (reportId) => {
  try {
    const { data } = await api.get(`/tta/report/${reportId}`);
    return data;
  } catch (error) {
    console.error("Ошибка при анализе с помощью AI:", error);
    throw error;
  }
};

export const getReports = async (params = {}) => {
  try {
    const response = await api.get(`/tta/reports`, {
      params,
    });
    console.log("response", response);

    const totalCount = response.headers["x-total-count"];
    const result = response.data;

    const hasProcessingReports = (result || []).some(
      (report) => report.status === "processing" || report.status === "pending"
    );

    return { reports: result, totalCount: +totalCount, hasProcessingReports };
  } catch (error) {
    return { reports: [], totalCount: 0, hasProcessingReports: false };
  }
};

export const getReportAnalytics = async (params = {}) => {
  try {
    const response = await api.get(`/tta/reports/analytics`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("getReportAnalytics failed:", error);
    throw error;
  }
};

export const deleteReport = async (reportId) => {
  try {
    return await api.delete(`/tta/report/${reportId}`);
  } catch (error) {
    console.error("Report deletion failed:", error);
    throw error;
  }
};

export const updateReport = async (reportId, title, description) => {
  try {
    return await api.put(`/tta/report/${reportId}`, {
      title,
      description,
    });
  } catch (error) {
    console.error("Report update failed:", error);
    throw error;
  }
};

export const addTagsToReport = async (reportId, tags) => {
  try {
    return await api.put(`/tta/report/${reportId}/tags`, {
      tag_ids: tags,
    });
  } catch (error) {
    console.error("Report update failed:", error);
    throw error;
  }
};

// add report to bookmarks
export const addReportToBookmarks = async (reportId) => {
  try {
    const response = await api.post(`/tta/report/${reportId}/bookmark`);
    const message = response.data.message;
    return {
      error: null,
      bookmark: message === "Report bookmarked successfully",
    };
  } catch (error) {
    console.error("Report add to bookmarks failed:", error);
    return {
      error: error.response.data.message,
      bookmark: false,
    };
  }
};

// remove report from bookmarks
export const removeReportFromBookmarks = async (reportId) => {
  try {
    await api.delete(`/tta/report/${reportId}/bookmark`);
    return {
      error: null,
      bookmark: false,
    };
  } catch (error) {
    console.error("Report remove from bookmarks failed:", error);
    return {
      error: error.response.data.message,
      bookmark: true,
    };
  }
};

export const whoami = async () => {
  try {
    const { data } = await api.get(`/users/me/`);
    return { isError: false, responseData: data };
  } catch (error) {
    return { isError: true, error };
  }
};

export const tagsApi = {
  getTags: async () => {
    try {
      const response = await api.get(`/tta/tags/`);
      return response.data || [];
    } catch (error) {
      console.error("Tags get failed:", error);
      return [];
    }
  },

  addTag: async (tag) => {
    try {
      const response = await api.post(`/tta/tags/`, tag);
      return response.data;
    } catch (error) {
      console.error("Tags add failed:", error);
      return { error: "Tags add failed" };
    }
  },

  updateTag: async (tag) => {
    try {
      const response = await api.put(`/tta/tags/${tag.tag_id}`, tag);
      return response.data;
    } catch (error) {
      console.error("Tags update failed:", error);
      return { error: "Tags update failed" };
    }
  },

  removeTag: async (tagId) => {
    try {
      const response = await api.delete(`/tta/tags/${tagId}`);
      return response.data;
    } catch (error) {
      console.error("Tags remove failed:", error);
      return { error: "Tags remove failed" };
    }
  },
};

export const calculateTokens = async (prompts, agentId = "report_agent") => {
  let prompt = [...reportPrompts, ...prompts];
  if (agentId === "ocr_agent") {
    prompt = [...prompts];
  }

  try {
    const response = await api.post(`/tta/report/precheck`, {
      prompt,
    });

    return response.data;
  } catch (error) {
    console.error("Ошибка при расчете токенов:", error);
    throw error;
  }
};

export const getOCRReportProgress = async (taskId) => {
  try {
    const response = await api.get(`/tta/deepseek/progress/${taskId}`);
    return response.data;
  } catch (error) {
    console.error("Ошибка при получении прогресса отчета:", error);
    throw error;
  }
};

export const usersApi = {
  getUsers: async (params = {}) => {
    try {
      const response = await api.get(`/users/`, { params });
      return response.data;
    } catch (error) {
      console.error("Organization members get failed:", error);
      throw error;
    }
  },
  searchUserByEmail: async (email) => {
    try {
      const response = await usersApi.getUsers({ email });
      console.log("searchUserByEmail", response);
      return response.payload;
    } catch (error) {
      console.error("User search by email failed:", error);
      throw error;
    }
  },
  createUser: async (userData) => {
    try {
      const response = await api.post(`/users/create/`, userData);
      return response.data;
    } catch (error) {
      console.error("User create failed:", error);
      throw error;
    }
  },
};

export const organizationApi = {
  my: async () => {
    try {
      const response = await api.get(`/organizations/list/`);
      return response.data;
    } catch (error) {
      console.error("Organization my get failed:", error);
      throw error;
    }
  },
  users: async () => {
    try {
      const response = await api.get(`/organizations/users/`);
      return response.data;
    } catch (error) {
      console.error("Organization members get failed:", error);
      throw error;
    }
  },
  update: async (organizationId, data) => {
    try {
      const response = await api.put(`/organizations/${organizationId}/`, data);
      return response.data;
    } catch (error) {
      console.error("Organization update failed:", error);
      throw error;
    }
  },
  switch: async (organizationId) => {
    try {
      const response = await api.post(`/organizations/transfer/`, {
        organization_id: organizationId,
      });
      return response.data;
    } catch (error) {
      console.error("Organization switch failed:", error);
      throw error;
    }
  },
  addUser: async (userId) => {
    try {
      const response = await api.post(`/organizations/users/add/`, {
        user_uuid: userId,
      });
      return response.data;
    } catch (error) {
      console.error("Organization add user failed:", error);
      throw error;
    }
  },
  removeUser: async (userId) => {
    try {
      const response = await api.delete(`/organizations/users/${userId}`);
      return response.data;
    } catch (error) {
      console.error("Organization remove user failed:", error);
      throw error;
    }
  },
};

export const updateUser = async (data) => {
  try {
    const response = await api.put(`/users/me/update/`, data);
    return response.data;
  } catch (error) {
    console.error("User update failed:", error);
    throw error;
  }
};
